import MapPin from "../../../../../../components/MapPin";
import GoogleMapReact from "google-map-react";
import React, {FC} from "react";
import styled from "styled-components/macro";

const GoogleMapReactWrapper = styled.div`
  height: 300px;
  width: 100%;
  position: relative;
`;

const getMapOptions = (maps: GoogleMapReact.Maps) => {
  return {
    fullscreenControl: true,
    mapTypeControl: true,
    mapTypeId: maps.MapTypeId.ROADMAP,
    scaleControl: true,
    scrollwheel: false,
    streetViewControl: true,
  };
}

type PropsType = {
  lat: number
  lng: number
  key?: string
  onDragEnd: (value: any) => void
}

const GoogleMapBlock: FC<PropsType> = ({
  lat,
  lng,
  key = 'AIzaSyD5R0bYPps6EYg2B4d1VFoZJ3lJrVlZX-s',
  onDragEnd
}) => {
  return (
    <GoogleMapReactWrapper>
      <div style={{
        position: "absolute",
        height: "100px",
        width: "100px",
        zIndex: 1,
        left: "50%",
        top: "50%",
        transform: "translate(-50%,-50%)",
      }}>
        <MapPin lat={lat} lng={lng} />
      </div>
      <GoogleMapReact
        options={getMapOptions}
        bootstrapURLKeys={{
          key: key,
        }}
        onDragEnd={onDragEnd}
        center={{
          lat: lat,
          lng: lng
        }}
        defaultZoom={14}
      >
      </GoogleMapReact>

    </GoogleMapReactWrapper>

  )
}

export default GoogleMapBlock